import { Component } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { TourController, TourStep } from 'src/assets/js/Tour/Tour';
import { ModalDoubleFactorComponent } from '../modal-double-factor/modal-double-factor.component';
import { SetTwoFactorResult } from 'src/app/Models/TwoFactor/set-twoFactor-result';
import { ModalInvalidPhoneComponent } from './modal-invalid-phone/modal-invalid-phone.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
enum Data {
  CORREO = 1,
  QR,
  WHATSAPP
}

enum Tour {
  STEP_ONE = 'step1'
}
@Component({
  selector: 'app-list-double-factor',
  templateUrl: './list-double-factor.component.html',
  styleUrls: ['./list-double-factor.component.scss'],
  standalone: true,
  imports: [
    MatIconModule
    , MatTableModule
    , MatSlideToggleModule
    , CommonModule
    , RouterModule
  ]
})

export class ListDoubleFactorComponent {
  displayedColumns: string[] = ["col1", "col2", "col3", "col4"];
  step1 = Tour.STEP_ONE;
  tour: TourController;

  constructor(
    public appStateService: AppStateService) {
    this.tour = new TourController();
    this.appStateService.cleanPaginator();
    queueMicrotask(() => this.onActualizar());
  }

  onActualizar = () => this.appStateService.TwoFactorService.ListTwoFactorByUser().subscribe();
  statusClass = (status: Boolean) => !status && 'pending' || 'finalized';
  descriptionClass(code: string) {
    if (!isNaN(Number(code))) {
      return Data[Number(code)].toLowerCase()
    }
    return '';
  }

  methodDescription(code: string): string {
    switch (Number(code)) {
      case Data.CORREO: return 'Deberá ingresar al portal con el código de acceso enviado a su correo electrónico';
      case Data.QR: return 'Deberá ingresar al portal con el código generado por la aplicación Google Authenticator';
      case Data.WHATSAPP: return 'Deberá ingresar al portal con el código enviado a su teléfono celular';
      default: return '';
    }
  }

  slideChanged(element: any, event: MatSlideToggleChange) {
    const { code, active } = element;

    if (active) {
      this.appStateService.TwoFactorService
        .DisableTwoFactor(code)
        .subscribe()
    }
    else {
      this.appStateService.TwoFactorService.setTwoFactor(code).subscribe(c => {

        if (c.success) {
          const data = Number(code),
            height = data === Data.QR ? 'auto' : '500px';

          const qrCode = (c as SetTwoFactorResult).googleTwoFactor?.qrCode || null;

          const dialog = this.appStateService.dialog.open(ModalDoubleFactorComponent, {
            maxWidth: '95%',
            maxHeight: '95%',
            width: '550px',
            height: 'auto',
            data: {
              code: data,
              qr: qrCode,
            },
          });
          dialog.beforeClosed().subscribe(c => {
            if (c?.action) {
              this.onActualizar();
            }
          });
        } else {
          const data = Number(code), height = data === Data.QR ? 'auto' : '450px';

          this.appStateService.dialog.open(ModalInvalidPhoneComponent, {
            maxWidth: '95%',
            maxHeight: '95%',
            width: '450px',
            height: 'auto',
          });
          event.source.checked = !event.checked;
        }
      });
    }
  }

  onStartTour() {
    const steps: TourStep[] = [
      {
        element: `#${this.step1}`,
        title: 'Autenticación en dos pasos',
        content:
          'La doble autenticación consiste en un código que se debe ingresar al momento de iniciar sesión, con el fin de proteger tu cuenta.',
      },
      {
        element: `#${this.step1}`,
        title: 'Autenticación en dos pasos',
        content:
          'Recibirás un código dinámico en tu correo o algún otro medio de los que se ofrecen a continuación y al ingresarlo correctamente, podrás iniciar sesión en el Portal Defontana',
      },
    ];

    this.tour.onConfigTour(steps);
    this.tour.onStartTour();
  }

}
